import { Platform } from 'react-native';
import Constants from 'expo-constants';

function isUsableMapsKey(key: unknown): key is string {
  if (typeof key !== 'string') return false;
  const trimmed = key.trim();
  return (
    trimmed.length > 20 &&
    !trimmed.includes('process.env') &&
    !trimmed.includes('YOUR_') &&
    trimmed !== 'your-api-key'
  );
}

/**
 * Android usa Google Maps y exige `com.google.android.geo.API_KEY` en el binario.
 * Sin key, montar `MapView` revienta el Fabric mount (redbox).
 * iOS usa Apple Maps; web usa el shim Leaflet.
 */
export function canRenderNativeMapView(): boolean {
  if (Platform.OS !== 'android') return true;
  const fromConfig = Constants.expoConfig?.android?.config?.googleMaps?.apiKey;
  // Metro inyecta EXPO_PUBLIC_* en el bundle; útil si Constants no expone la key.
  const fromEnv = process.env.EXPO_PUBLIC_GOOGLE_MAPS_API_KEY;
  return isUsableMapsKey(fromConfig) || isUsableMapsKey(fromEnv);
}
